module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.extras.length > 0) ? _c('div', {
    staticClass: "row w-100"
  }, [_vm._m(0), _vm._v(" "), (_vm.componentRuleType !== 1) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Price")])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.componentRuleType === 1) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Percent")])]) : _vm._e(), _vm._v(" "), (_vm.componentRuleType === 2) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Remaining Value")])]) : _vm._e(), _vm._v(" "), (_vm.componentRuleType !== 1 || _vm.componentRuleType === 2 && _vm.isPricePerGroup) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("PVP")])]) : _vm._e(), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.priceObj) ? _c('div', _vm._l((_vm.priceObj.productGenderPriceComponents), function(service, index) {
    return _c('split-price-editor-row', {
      key: index,
      attrs: {
        "service": service,
        "index": index,
        "componentRuleType": _vm.componentRuleType,
        "disabled": _vm.disabled,
        "isPricePerGroup": _vm.isPricePerGroup
      },
      on: {
        "this-is-valid-row": function($event) {
          return _vm.rowIsValid($event)
        },
        "change": function($event) {
          return _vm.updateRowToStore()
        },
        "removePrice": _vm.removePrice,
        "remaining-selected": _vm.onRemainingSelected
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.extras.length == 0 && !_vm.disabled) ? _c('div', {
    staticClass: "row d-flex justify-content-center text-center dark p-4"
  }, [_c('span', [_vm._v("✨ Looks like you have no services created, please create them "), _c('span', {
    staticClass: "bold underlined pointer",
    on: {
      "click": _vm.createExtraClick
    }
  }, [_vm._v("here")]), _vm._v(".")])]) : _c('div', {
    staticClass: "row mt-3 w-100"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.disabled) ? _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold",
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add service\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "error-min-height"
  }, [(_vm.componentRuleType == 1 && _vm.priceObj.productGenderPriceComponents.length > 0 && _vm.sumPercentValues != 100) ? _c('span', {
    staticClass: "row d-flex justify-content-center text-center fs-small color-6"
  }, [_vm._v("The sum of percent values must be 100%\n        ")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v(" ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-57e4066e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e4066e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/SplitPriceEditor.vue
// module id = 1462
// module chunks = 0